import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";

type StorageContext = {
  setLocalStorage: (key: string, value: string) => void;
  getLocalStorage: (key: string) => string | null;
  setSessionStorage: (key: string, value: string) => void;
  getSessionStorage: (key: string) => string | null;
  wipeSessionStorage: () => void;
};

const StorageContext = createContext({} as StorageContext);

export const StorageProvider: FC<PropsWithChildren> = ({ children }) => {
  //  API
  const api: StorageContext = useMemo(() => {
    const setLocalStorage = (key: string, value: string) =>
      window.localStorage.setItem(key, value);
    const getLocalStorage = (key: string) => window.localStorage.getItem(key);
    const setSessionStorage = (key: string, value: string) =>
      window.sessionStorage.setItem(key, value);
    const getSessionStorage = (key: string) =>
      window.sessionStorage.getItem(key);
    const wipeSessionStorage = () => {
      window.sessionStorage.clear();
      window.location.reload();
    };
    return {
      setLocalStorage,
      getLocalStorage,
      setSessionStorage,
      getSessionStorage,
      wipeSessionStorage,
    };
  }, []);

  return (
    <StorageContext.Provider value={api}>{children}</StorageContext.Provider>
  );
};

export const useStorageAPI = () => useContext(StorageContext);
